// extracted by mini-css-extract-plugin
export default {"bodyReset":"ResetPasswordForm_bodyReset__dnfbG","resetForm":"ResetPasswordForm_resetForm__DjFyE"};